<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Action :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/admin/divisions">
                            Divisions
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-trash"></i> Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <h4 class="card-header">Delete Division</h4>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> This change cannot be undone.
                            </div>
                            <div v-bind:class="{ 'form-group': true }" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Delete Division:</label>
                                <div class="col-sm-8">
                                    <h3>{{ division.division_code }} - {{ division.DivisionName }}</h3>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.other_division_id }" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">
                                    Re-assign Jobsite Division
                                </label>
                                <div class="col-sm-8">
                                    <select v-model="other_division_id" class="form-control">
                                        <option :value="null">-- Select a Division to Re-assign All Jobsites --</option>
                                        <option v-for="(value, key) in other_divisions" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <span v-if="errors.other_division_id" class="text-danger">
                                        <span v-for="error in errors.other_division_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <small style="color: #949494;">Every Jobsite must have a division, so in order to delete this division, EHS must re-assign the deleted Division's Jobsites.</small>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteDivision(this)" :disabled="saving">Delete Division</button>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                division_id: this.$route.params.id,
                other_division_id: null,
                other_divisions: {},
                division: {},
                errors: {},
                files: [],
            }
        },
        methods: {
            getDivision: function() {
                //Get the data
                this.$http
                    .get('admin/divisions-delete/' + this.division_id)
                    .then(response => {
                        //Set all the data
                        this.division = response.data.division;
                        this.other_divisions = response.data.other_divisions;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteDivision: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/divisions-delete/' + this.division_id, {
                    'other_division_id': this.other_division_id,
                    'DivisionId': this.division_id
                })
                .then(response => {
                    //Create the messgae
                    var deleteMessage = 'Division Deleted';

                    //Alert the user?
                    this.$toastr.success(deleteMessage);

                    //Return to main list?
                    this.$router.push('/admin/divisions');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the incidents
            this.getDivision();
        }
    }
</script>
